import { ThemeInterface } from './theme-interface';
import { defaultTheme } from './default-theme';
import { getThemeIconsLight, ThemeMap } from './theme-map';

const sonnenTheme: ThemeInterface = {
  name: ThemeMap.SONNEN,
  type: defaultTheme.type,
  styles: {
    global: [{ themeVariable: '--ion-item-background', value: 'white' }],
    brandPrimary: [
      { themeVariable: '--ion-color-brand-primary', value: '#00131D' },
      { themeVariable: '--ion-color-brand-primary-rgb', value: '0, 19, 29' },
      { themeVariable: '--ion-color-brand-primary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-brand-primary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-brand-primary-shade', value: '#00111a' },
      { themeVariable: '--ion-color-brand-primary-tint', value: '#1a2b34' },
    ],
    textPrimary: defaultTheme.styles.textPrimary,
    textTertiary: defaultTheme.styles.textTertiary,
    textSecondary: defaultTheme.styles.textSecondary,
    backgroundPrimary: [
      { themeVariable: '--ion-color-background-primary', value: '#EDEDEF' },
      { themeVariable: '--ion-color-background-primary-rgb', value: '237, 237, 239' },
      { themeVariable: '--ion-color-background-primary-contrast', value: '#000000' },
      { themeVariable: '--ion-color-background-primary-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-background-primary-shade', value: '#d1d1d2' },
      { themeVariable: '--ion-color-background-primary-tint', value: '#efeff1' },
    ],
    backgroundSecondary: [
      { themeVariable: '--ion-color-background-secondary', value: '#A4A395' },
      { themeVariable: '--ion-color-background-secondary-rgb', value: '164, 163, 149' },
      { themeVariable: '--ion-color-background-secondary-contrast', value: '#000000' },
      { themeVariable: '--ion-color-background-secondary-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-background-secondary-shade', value: '#908f83' },
      { themeVariable: '--ion-color-background-secondary-tint', value: '#adaca0' },
    ],
    backgroundTertiary: [
      { themeVariable: '--ion-color-background-tertiary', value: '#00131D' },
      { themeVariable: '--ion-color-background-tertiary-rgb', value: '0, 19, 29' },
      { themeVariable: '--ion-color-background-tertiary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-background-tertiary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-background-tertiary-shade', value: '#00111a' },
      { themeVariable: '--ion-color-background-tertiary-tint', value: '#1a2b34' },
    ],
    subTabLabels: [
      { themeVariable: '--ion-color-sub-tab-labels', value: '#3A245E' },
      { themeVariable: '--ion-color-sub-tab-labels-rgb', value: '58,36,94' },
      // at the moment using the contrast value for the tab labels
      { themeVariable: '--ion-color-sub-tab-labels-contrast', value: '#424B50' },
      { themeVariable: '--ion-color-sub-tab-labels-contrast-rgb', value: '66, 75, 80' },
      { themeVariable: '--ion-color-sub-tab-labels-shade', value: '#332053' },
      { themeVariable: '--ion-color-sub-tab-labels-tint', value: '#4e3a6e' },
    ],
    solar: defaultTheme.styles.solar,
    consumption: defaultTheme.styles.consumption,
    battery: defaultTheme.styles.battery,
    consumed: defaultTheme.styles.consumed,
  },
  headerLogo: {
    path: getThemeIconsLight[ThemeMap.SONNEN],
    style: {
      height: '30px',
    },
  },
  footerLogo: defaultTheme.footerLogo,
  footerColoredLogo: defaultTheme.footerColoredLogo,
  iconsSvgPath: defaultTheme.iconsSvgPath,
  chartColors: {
    primary: { value: '#FFD357', opacValue: 'rgba(255, 211, 87, 0.4)' },
    light: { value: '#00131D', opacValue: 'rgba(0, 19, 29, 0.4)' },
    secondary: { value: '#4696EC', opacValue: 'rgba(70, 150, 236, 0.4)' },
    tertiary: { value: '#008A32', opacValue: 'rgba(0, 178, 153, 0.4)' },

    colorFive: { value: '#7BA24B', opacValue: 'rgba(123, 162, 75, 0.4)' },
    colorSix: { value: '#3933DE', opacValue: 'rgba(57, 51, 222, 0.4)' },
    colorSeven: { value: '#AE33DE', opacValue: 'rgba(174, 51, 222, 0.4)' },
    colorEight: { value: '#6B9FAF', opacValue: 'rgba(107, 159, 175, 0.4)' },
    colorNine: { value: '#DE3355', opacValue: 'rgba(222, 51, 85, 0.4)' },
    colorTen: { value: '#96F70D', opacValue: 'rgba(150, 247, 13, 0.4)' },
  },
  vppChartColors: defaultTheme.vppChartColors,
  streamChartColor: '#00131D',
  buttons: {
    primary: [
      { themeVariable: '--ion-color-button-primary', value: '#00131D' },
      { themeVariable: '--ion-color-button-primary-rgb', value: '0, 19, 29' },
      { themeVariable: '--ion-color-button-primary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-button-primary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-button-primary-shade', value: '#00111a' },
      { themeVariable: '--ion-color-button-primary-tint', value: '#1a2b34' },
    ],
    secondary: [
      { themeVariable: '--ion-color-button-secondary', value: '#FF4B4E' },
      { themeVariable: '--ion-color-button-secondary-rgb', value: '255, 75, 78' },
      { themeVariable: '--ion-color-button-secondary-contrast', value: '#000000' },
      { themeVariable: '--ion-color-button-secondary-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-button-secondary-shade', value: '#e04245' },
      { themeVariable: '--ion-color-button-secondary-tint', value: '#ff5d60' },
    ],
    success: [
      { themeVariable: '--ion-color-success', value: '#92CE62' },
      { themeVariable: '--ion-color-success-rgb', value: '146, 206, 98' },
      { themeVariable: '--ion-color-success-contrast', value: '#000000' },
      { themeVariable: '--ion-color-success-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-success-shade', value: '#80b556' },
      { themeVariable: '--ion-color-success-tint', value: '#9dd372' },
    ],
    warning: [
      { themeVariable: '--ion-color-warning', value: '#FFD357' },
      { themeVariable: '--ion-color-warning-rgb', value: '255, 211, 87' },
      { themeVariable: '--ion-color-warning-contrast', value: '#000000' },
      { themeVariable: '--ion-color-warning-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-warning-shade', value: '#e0ba4d' },
      { themeVariable: '--ion-color-warning-tint', value: '#ffd768' },
    ],
    danger: [
      { themeVariable: '--ion-color-danger', value: '#E31E30' },
      { themeVariable: '--ion-color-danger-rgb', value: '227, 30, 48' },
      { themeVariable: '--ion-color-danger-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-danger-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-danger-shade', value: '#c81a2a' },
      { themeVariable: '--ion-color-danger-tint', value: '#e63545' },
    ],
    successLite: [
      { themeVariable: '--ion-color-success-lite', value: '#B5EECC' },
      { themeVariable: '--ion-color-success-lite-rgb', value: '181, 238, 204' },
      { themeVariable: '--ion-color-success-lite-contrast', value: '#000000' },
      { themeVariable: '--ion-color-success-lite-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-success-lite-shade', value: '#9fd1b4' },
      { themeVariable: '--ion-color-success-lite-tint', value: '#bcf0d1' },
    ],
    warningLite: [
      { themeVariable: '--ion-color-warning-lite', value: '#FEEACB' },
      { themeVariable: '--ion-color-warning-lite-rgb', value: '254, 234, 203' },
      { themeVariable: '--ion-color-warning-lite-contrast', value: '#000000' },
      { themeVariable: '--ion-color-warning-lite-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-warning-lite-shade', value: '#e0ceb3' },
      { themeVariable: '--ion-color-warning-lite-tint', value: '#feecd0' },
    ],
    dangerLite: [
      { themeVariable: '--ion-color-danger-lite', value: '#FFDFDF' },
      { themeVariable: '--ion-color-danger-lite-rgb', value: '255, 223, 223' },
      { themeVariable: '--ion-color-danger-lite-contrast', value: '#000000' },
      { themeVariable: '--ion-color-danger-lite-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-danger-lite-shade', value: '#e0c4c4' },
      { themeVariable: '--ion-color-danger-lite-tint', value: '#ffe2e2' },
    ],
  },
  svgIcons: {
    primarySvg: [
      { themeVariable: '--ion-color-primary-svg', value: '#00131D' },
      { themeVariable: '--ion-color-primary-svg-rgb', value: '0, 19, 29' },
      { themeVariable: '--ion-color-primary-svg-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-primary-svg-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-primary-svg-shade', value: '#00111a' },
      { themeVariable: '--ion-color-primary-svg-tint', value: '#1a2b34' },
    ],
  },
  tablesRow: {
    primaryTile: [
      { themeVariable: '--ion-color-table-primary-tile', value: '#F8F8F8' },
      { themeVariable: '--ion-color-table-primary-tile-rgb', value: '248, 248, 248' },
      { themeVariable: '--ion-color-table-primary-tile-contrast', value: '#000000' },
      { themeVariable: '--ion-color-table-primary-tile-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-table-primary-tile-shade', value: '#dadada' },
      { themeVariable: '--ion-color-table-primary-tile-tint', value: '#f9f9f9' },
    ],
    secondaryTile: [
      { themeVariable: '--ion-color-table-secondary-tile', value: '#EDEDEF' },
      { themeVariable: '--ion-color-table-secondary-tile-rgb', value: '237, 237, 239' },
      { themeVariable: '--ion-color-table-secondary-tile-contrast', value: '#000000' },
      { themeVariable: '--ion-color-table-secondary-tile-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-table-secondary-tile-shade', value: '#d1d1d2' },
      { themeVariable: '--ion-color-table-secondary-tile-tint', value: '#efeff1' },
    ],
    grayTile: [
      { themeVariable: '--ion-color-table-gray-tile', value: '#F3F3F3' },
      { themeVariable: '--ion-color-table-gray-tile-rgb', value: '243, 243, 243' },
      { themeVariable: '--ion-color-table-gray-tile-contrast', value: '#000000' },
      { themeVariable: '--ion-color-table-gray-tile-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-table-gray-tile-shade', value: '#d6d6d6' },
      { themeVariable: '--ion-color-table-gray-tile-tint', value: '#f4f4f4' },
    ],
  },
};

export { sonnenTheme };
